export default {
    //首页
    index: {
        content: "「心光（しんこう）」はあなたのAIライフパートナー。まるで生活版のNotionのような存在です。テキスト、音声、写真や動画、インスピレーション、感情の吐き出し、音楽やポッドキャスト、運動記録など、あらゆる日常をオールインワンで記録できます。同時に、あなた自身が設定したAIの友達が、あなたの心に寄り添い、共感したり、深い対話をしてくれます。",
        contentTips: "——日々の積み重ねが、あなた自身の「人生の書」となり、世界で一番あなたを理解してくれるAIの友達ができるのです。",
        iosDownload: "iOSでダウンロード"
    },
    //菜单
    header: {
        home: 'ホーム',
        about: '私たちについて'
    },
    //关于页面
    aboutUs: {
        content: "「心光」の使命：ユーザーに寄り添い、応え、整理を助ける個人の小さな世界を構築し、思考や感情が丁寧にケアされるようにします。強力なAI技術を組み合わせることで、「心光」のAIフレンドは、あなたの生活の傾聴者であり、有能なアシスタントとして、人生に寄り添い、より良い自分になるためのサポートをします。",
        //联系我们
        contact: "お問い合わせ",
        //注销账号
        contactTips1:"アカウントの削除をご希望の場合は、moodlightnlp2025@gmail.com までメールをお送りください。メール内にお客様の電話番号またはメールアドレス情報をご記載いただければ、迅速に対応させていただきます！",
        contactTips2:"アカウントの削除は危険な操作です。本当に削除するか確認してください。アカウント削除を完了すると、アカウントは3日間のクールダウン期間に入ります。この期間中にアカウントに再度ログインすると、アカウント削除はキャンセルされます。クールダウン期間が終了すると、アカウント情報は削除され、復元できなくなります。アプリケーションデータはアプリ内に保存されているため、削除したい場合は単にアプリを削除すれば、データも一緒に削除されます。",
    },
    //隐私政策
    privacy_policy: {
        title: "プライバシーポリシー",
        company: "運営会社：深圳市心里有光科技有限公司",
        published_on: "本プライバシーポリシーは2024年12月20日に公開されました。",
        updated_on: "本プライバシーポリシーは2025年04月07日に更新されました。",
        description: "心光（シングァン）は深圳市心里有光科技有限公司（以下「心里有光科技有限公司」または「当社」といいます）が提供するAIライフ記録パートナーです。心里有光科技有限公司はお客様の個人情報およびデータを非常に重要視し、安全で信頼できる方法で保護することをお約束します。本アプリケーション（以下、「当アプリケーション」または「心光」といいます）はユーザーのプライバシーを非常に重視しており、関連する法律・規則を厳守しています。ご使用を続ける前に『プライバシーポリシー』をよくお読みください。当社のサービスをご利用いただくことは、当社の契約内容をすべて理解されたものとみなされます。",
        helpYouKnow: "このポリシーにより、以下の内容についてご理解いただけます：",
        sections: [
            "1. 当社がどのようにしてあなたの個人情報を収集するか",
            "2. 当社がどのようにしてあなたの個人情報を保存するか",
            "3. 当社がどのようにしてあなたの個人情報の安全性を確保するか",
            "4. Cookieおよび類似技術の利用",
            "5. 当社がどのようにしてあなたの個人情報を利用するか",
            "6. 情報の管理方法",
            "7. 情報の開示",
            "8. 子供に関する個人情報の取り扱い",
            "9. プライバシーポリシーの変更",
            "10. お問い合わせ方法"
        ],
        disclaimer: "当アプリケーションはすべての利用ユーザーの個人プライバ権を尊重し、保護しています。より正確で高品質なサービスを提供するために、当アプリケーションは本プライバシーポリシーに従って個人情報を使用・開示します。本プライバシーポリシーに別段の定めがない限り、事前の許可なくこれらの情報を第三者や外部に開示することはありません。当アプリケーションは随時、本プライバシーポリシーを更新することがあります。当アプリケーションの利用規約に同意した時点で、本プライバシーポリシーの全内容に同意したものとみなされます。",
        //第一节
        section1: {
            declare: "心光をご利用いただく際に、ご自身が提供する情報やサービス利用によって生成される情報を以下の通り収集します。この情報はサービス提供、サービスの最適化、アカウントのセキュリティ確保のために利用されます。",
            declares: [
                "1. 心光のサービスに登録する際、ニックネーム、プロフィール画像、電話番号を収集します。これらは登録完了とアカウントの保護のために必要です。電話番号はセンシティブ情報であり、ネット実名制などの法律に基づき収集されます。これらの情報を提供しない場合、サービスが正しく利用できない可能性があります。性別や自己紹介文なども任意で入力可能です。",
                "2. 心光をご利用中に、サービスの正常な運用、改善、セキュリティ確保のために、デバイスモデル、OS、固有デバイスID（メーカーにより組み込まれた一意の文字列）、ログインIPアドレス、ソフトウェアバージョン、ネットワーク接続方法・状態、通信品質データ、加速度センサー、操作ログ、検索履歴、エラーログ、リファラURLなどのサービスログ情報を収集します。これらはサービス提供に必要な基本情報です。",
                "3. 日常的な記録を行う際、テキスト、写真、動画などを含む情報を取得し、アプリ内に保存します。サーバーへの保存可否を選択できますが、これは機能実現に必要なためです。暗号化して保存し、削除も可能です。ただし、自主的に選択した場合や法律要件がある場合を除き、外部提供や他の用途には使用しません。",
                "4. 会員契約や支払い履歴などの情報はサーバーに保存され、これらはソフトウェア機能に必要な情報です。支払い機能をご利用の場合、第三者の支払いサービス提供企業が直接関連情報を収集します。",
                "5. AI関連機能を使用する場合、記録情報などのユーザー情報をAIサービス提供企業に提供するものとみなします。",
                "6. サービス提供のため、心光は端末から以下の権限を取得することがあります。当然ながら、設定でこれらの権限を拒否または無効にすることもでき、その場合でも他の機能は引き続きご利用いただけます：",
            ],
            sixth: [
                "（1）カメラアクセス：写真撮影とアップロードが可能になります；",
                "（2）電話およびSMS受信：電話番号による認証コード受信とログインが可能になります；",
                "（3）ローカルストレージアクセス：アプリ更新やローカル写真・動画のアップロードが可能になります；",
                "（4）写真アクセス：端末内の写真や画像を直接選択してアップロードできます；",
                "（5）無線データアクセス：Wi-Fiやセルラー通信でのネット接続が必要になります；",
                "また、関連する法律・国家基準に基づき、次の場合は事前の同意なしに個人情報を収集・使用する場合があります：",
            ],
            sixthPoint: [
                "a) 個人情報管理者が法律上の義務を遂行するためのもの；",
                "b) 国家安全・国防に関係するもの；",
                "c) 公共安全・公衆衛生・重大な公共利益に関係するもの；",
                "d) 刑事捜査・起訴・裁判・判決執行に関係するもの；",
                "e) 生命・財産などの重大な権利を守るためだが本人の同意を得るのが困難なもの；",
                "f) 個人情報主体が自ら公開した情報；",
                "g) 契約締結・履行のために必要なもの；",
                "h) 合法的に公表された情報（例：報道記事、政府情報開示）からの収集；",
                "i) 提供する製品・サービスの安定運用に必要なもの（例：障害発見・対処）；",
                "j) ニュース機関による合法的な報道活動に必要なもの；",
                "k) 学術研究機関による公共利益に基づく統計・研究に必要なもので、結果は匿名化されているもの；",
            ],
            understand: "当社の提供する機能・サービスは継続的に進化しています。説明に含まれていない機能やサービスで個人情報を収集する場合は、ページ内通知やサイト公告などで収集内容・目的を明確にし、同意をいただきます。",
            notice: "現時点では、心光は外部の第三者から積極的にあなたの個人情報を収集することはございません。今後、事業展開により第三者経由で情報を取得する場合には、事前に情報の出所・種類・利用範囲を明確にいたします。また、関連法規を厳守し、第三者に対しても情報の合法性を保証させます。"
        },
        //第二节
        section2: {
            titles: [
                "1. 情報の保存場所",
                "2. 情報の保存期間",
                "3. アカウント情報の作成と削除"
            ],
            firstPoint: "現在、あなたのほとんどのデータはアプリ内で保存されており、アカウント情報などの一部のデータは心光サーバーに保存されています。中国国内で収集されたユーザーの個人情報については、関連する法律・規則に基づき中国国内で保管します。もし個人情報を中国国外に移動する必要がある場合は、法律に基づいて厳格に対応いたします。",
            secondPoint: {
                content: "原則として、目的達成のために必要な期間のみ個人情報を保持します。例えば以下の通りです。",
                points: [
                    "電話番号：心光サービスをご利用の場合、正常なサービス利用を保障するため、電話番号を継続して保存します。アカウントを削除した際には、当該情報を削除いたします。",
                    "ユーザー情報：心光サービスをご利用の場合、正常なサービス利用を保障するため、ニックネーム、性別、自己紹介文などを継続して保存します。アカウントを削除した際には、当該情報を削除いたします。"
                ]
            },
            thirdPoint: [
                "アプリ内で電話番号を使用して登録する場合、その電話番号からアプリ内アカウントが生成されます。",
                "アカウントを削除したい場合は、[設定] → [アカウントとセキュリティ] → [アカウント削除] を選択してください。アカウント削除後、すべてのアカウント情報およびユーザー情報が削除され、復元することはできません。削除前に必要なユーザー情報を必ずエクスポートしてください。"
            ]
        },
        //第三节
        section3: {
            content: [
                "ユーザー情報の安全性を守るために努めています。情報の紛失、不正な使用、許可されていないアクセスや開示を防ぐための対策を講じています。",
                "適切なセキュリティレベル内で多様な保護策を使用して情報を安全に保管します。例えば、SSLなどの暗号化技術や匿名化処理により、あなたの個人情報を保護しています。",
                "インストールされたアプリケーションのセキュリティ強化を通じて、あなたの端末上の個人情報漏洩を防止します。たとえば、通信の安全性を確保するため、端末でデータを暗号化処理したり、ウイルス・トロイの木馬・その他の悪質なプログラムやサイトを防ぐために、あなたがインストールしたアプリ情報や実行中のプロセス、メモリ内のデータなどを把握することがあります。また、詐欺・アカウント乗っ取り・なりすましなどの不正行為を防ぐため、固有デバイスID、ログインIPアドレス、操作ログ、位置情報などのデータを分析し、セキュリティ対策や警告を行います。",
                "情報の安全性を確保するため、専門の管理体制・プロセス・チームを設けています。たとえば、情報へのアクセス権限を厳しく制限し、従業員には秘密保持義務を課し、監査を定期的に実施しています。",
                "万が一個人情報の漏洩などのセキュリティ事故が発生した場合は、緊急対応計画を発動し、被害拡大を防ぎ、プッシュ通知や掲示板などによりお知らせします。",
                "私たちはあなたの個人情報の保護に尽力いたします。ただし、どんなセキュリティ対策も完全ではないことをご理解いただけますようお願い申し上げます。"
            ]
        },
        //第四节
        section4: {
            content: [
                "Cookieの受け入れを拒否しない場合、本アプリケーションはあなたの端末にCookieを設定またはアクセスし、ログインやCookieに依存するサービスや機能をご利用いただけるようにします。本アプリケーションはCookieを使用して、より充実したサービス（プロモーションなど）を提供します。",
                "本アプリケーションが設定したCookieから取得された情報については、本プライバシーポリシーが適用されます。"
            ]
        },
        //第五节
        section5: {
            content: [
                "特定の機能を通じて収集された情報は、他のサービスにも活用される場合があります。たとえば、ある機能やサービスをご利用中に収集した情報を処理・分析し、データの分類表示、閲覧履歴に基づくセキュリティ通知、特徴タグを基にした間接的なユーザー分析によるより正確なサービス・コンテンツ提供、ユーザー権益や心光エコシステムの安全を守る目的で統計サービスを提供します。",
                "サービスの安全性を確保し、アプリケーションの動作状況をより深く理解するために、ご使用頻度、クラッシュデータ、全体的な使用状況、パフォーマンスデータ、アプリケーションの導入元などの情報を記録する場合があります。分析ツールに保存された情報は、アプリ内で提供された個人識別情報とは一切関連付けません。",
                "あなたの個人情報を当初収集した目的や直接または合理的に関連する範囲を超えて使用する場合は、事前に再度通知を行い、明示的な同意を得た上で使用いたします。"
            ]
        },
        //第六节
        section6: {
            title: [
                "1. 情報管理",
                "2. アカウント削除"
            ],
            content1: [
                "私たちはあなたの個人情報への関心を非常に重視しており、アクセス・修正・削除の権利を保護し、プライバシーとセキュリティを守れるよう努めています。",
                "私たちが収集したあなたの情報に誤りがある場合、修正や追加を要請する権利があります。サービス提供中にアルバム、カメラ、マイク、電話帳などのデバイス権限が必要になることがあります。端末の【設定】から一部またはすべての権限をいつでも無効化することで、当アプリによる個人情報の収集を拒否できます。端末によっては表示方法や設定手順が異なるため、端末およびOS開発元の説明書などをご参照ください。"
            ],
            content2: [
                "「洞察 → 設定 → アカウントとセキュリティ → アカウント削除」を選択すると、携帯番号で本人確認を求められます。",
                "「削除を確定」をクリックし、本人確認が完了して削除意思が変わらなければ、アカウントは削除冷却期間に入ります。この間はアカウントを使用できませんが、復元を依頼することも可能です。冷却期間終了後に完全に削除されます。すぐに削除したい場合はメールで連絡いただければ即時対応いたします。また、その他のデータはアプリ内に保存されているため、心光アプリを削除することでデータも同時に削除されます。",
                "アカウント削除は取り消せない操作であることをご了承ください。一度削除した場合、アプリは今後のサービス提供を停止し、速やかに個人情報を削除または匿名化します（ただし法律で別段の定めがある場合は除く）。"
            ]
        },
        //第七节
        section7: {
            notice: "次のいずれかに該当する場合、アプリケーションはあなたの個人情報を一部または全部開示することがあります。これはあなたの同意または法律に基づくものです。",
            notices: [
                "(a) 事前にあなたの同意がない限り、第三者に情報を開示することはありません；",
                "(b) あなたが要請した製品・サービスを提供するために、第三者とあなたの個人情報を共有する必要がある場合があります；",
                "(c) 法律の規定や行政・司法機関からの要請に基づき、第三者または行政・司法機関に情報を開示することがあります；",
                "(d) 中国の関連法律・規則、本アプリケーションの利用契約または関連ルールに違反した場合、第三者に情報を開示する必要があります；",
                "(e) 適格な知的財産権侵害に関する苦情申立てを行った場合、相手側の要請により、両者間の権利問題を解決するために相手に情報を開示することがあります；"
            ],
            title: [
                "1. 共有",
                "2. 譲渡",
                "3. 公開開示",
                "4. 委託処理",
                "5. 第三者パートナーとの情報開示について"
            ],
            content1: [
                {
                    title: "（1）他のユーザーによる検索",
                    content: "本アプリケーション内で他のユーザーがあなたのプロフィールページや投稿されたアイテムを検索できるようにすることで、ユーザー間のやり取りを容易にします。"
                },
                {
                    title: "（2）クレーム対応",
                    content: "あなたが誰かを苦情申立てしたり、逆にあなたが苦情申立てを受けた場合、双方の正当な権利利益を守り、健全な交換環境を維持するために、氏名・本人確認書類番号・連絡先・クレーム内容などを関係当局に提供する可能性があります。ただし、法律で明確に開示が禁止されている場合は除きます。"
                }
            ],
            content2: {
                notice: "あなたの個人情報をいかなる企業・団体・個人にも譲渡しません。ただし、以下の場合は例外です：",
                notices: [
                    "（1）事前にあなたの明確な同意を得た場合；",
                    "（2）法律・規則や強制的な行政・司法の要請に基づく場合；",
                    "（3）資産譲渡、買収、合併、再編または破産清算において個人情報の譲渡が必要になる場合、あなたに状況を通知し、新たな保有者に対しても本ポリシーの遵守を求めます。また、情報処理の目的や方法が変更される場合には、再度あなたの明確な同意を求めます。"
                ]
            },
            content3: {
                notice: "基本的にはあなたの情報を公開開示することはありません。ただし、やむを得ず開示が必要な場合は、開示の目的、開示する情報の種類および関連するセンシティブ情報について通知し、事前にあなたの明確な同意をいただきます。"
            },
            content4: {
                notice: "情報処理の効率向上、コスト削減、または正確性の向上のために、当社の関連会社または専門機関に情報を委託して処理をお願いする場合があります。これらの委託先には、書面契約や現地調査などを通じて、厳格な秘密保持義務と有効なセキュリティ対策を求めており、あなたの許可を超えて情報を利用する行為を禁止しています。また、委託契約が終了した時点で、委託先はすべての個人情報を削除し、以後一切保有しません。当社はこの責任を全面的に負います。"
            },
            content5: {
                services: [
                    {
                        title: "1）支払いサービスプロバイダー（1）：深圳騰訊コンピューターシステム有限公司が提供するサービスで、一般的なデバイス情報（IMEI/IMSI、SIMカードシリアル番号/MACアドレス、android_id）、ネットワーク情報およびソフトウェアインストールリストを収集し、支払いサービスをご利用いただけます。詳しくは以下をご覧ください。",
                        policyName: "「WeChat プライバシーポリシー」",
                        sdkTips: "支払いサービスプロバイダーが使用する必要のある関連SDK：",
                        link: "https://weixin.qq.com/cgi-bin/readtemplate?lang=ja_JP&t=weixin_agreement&s=privacy",
                        tips: "WeChat SDK：WeChatペイメント、共有、ログイン機能に使用"
                    },
                    {
                        title: "2）支払いサービスプロバイダー（2）：支付宝（中国）ネットワーク技術有限公司が提供するサービスで、IMEI、IMSI、MACアドレス、デバイスシリアル番号、ハードウェアシリアル番号、SIMカードシリアル番号、ICCID、AndroidID、OAID、SSID、BSSID；システム設定、システムプロパティ、デバイスモデル、デバイスブランド、オペレーティングシステム；IPアドレス、ネットワークタイプ、通信キャリア情報、Wi-Fi状況、Wi-Fiパラメーター、Wi-Fi一覧；ソフトウェアインストールリストを収集し、支払いサービスをご利用いただけます。詳しくは以下をご覧ください。",
                        policyName: "「支付宝プライバシーポリシー」",
                        sdkTips: "クレジットサービスプロバイダーが使用する必要のある関連SDK：",
                        link: "https://opendocs.alipay.com/common/02kiq3",
                        tips: "支付宝決済SDK：支付宝の決済機能に使用"
                    },
                    {
                        title: "3）エラー報告サービスプロバイダー：騰訊科技（北京）有限公司が提供するサービスで、一般的なデバイス情報（IMEI/IMSI、SIMカードシリアル番号/MACアドレス、android_id）とネットワーク情報を収集し、ユーザーが使用中に発生したエラーを報告して、体験向上を図ります。詳しくは以下をご覧ください。",
                        policyName: "「Bugly Crash SDK プライバシー保護声明」",
                        sdkTips: "エラー報告サービスプロバイダーが使用する必要のある関連SDK：",
                        link: "https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56",
                        tips: "騰訊Bugly SDK：アプリ内のクラッシュ情報を統計するために使用"
                    },
                    {
                        title: "4）共有サービスプロバイダー（1）：行吟信息科技（上海）有限公司が提供するサービスで、一般的なデバイス情報（OS、システムバージョン、デバイスモデル）とネットワーク情報を収集し、小紅書共有サービスをご利用いただけます。詳しくは以下をご覧ください。",
                        policyName: "「小紅書Open SDK 個人情報処理に関する説明」",
                        sdkTips: "共有サービスプロバイダーが使用する必要のある関連SDK：",
                        link: "https://agree.xiaohongshu.com/h5/terms/ZXXY20230525001/-1",
                        tips: "- 小紅書共有SDK：小紅書への共有転送に使用"
                    },
                    {
                        title: "5）音声認識サービスプロバイダー：阿里雲計算有限公司が提供するサービスで、使用中にデバイス情報を一切収集せず、音声認識サービスを提供します。詳しくは以下をご覧ください。",
                        policyName: "「スマート音声インタラクティブ製品 プライバシーポリシー」",
                        sdkTips: "音声認識サービスプロバイダーが使用する必要のある関連SDK：",
                        link: "https://terms.alicdn.com/legal-agreement/terms/b_platform_service_agreement/20240325163900980/20240325163900980.html?spm=a2c4g.11186623.0.0.62e34f4dX2l2z4",
                        tips: "- スマート音声インタラクティブモバイルSDK：音声インタラクティブ機能に使用"
                    },
                    {
                        "title": "6）電話番号認証サービスプロバイダー：アリババクラウドコンピューティング有限公司がサービスを提供し、お客様に電話番号ワンクリックログインサービスをご提供するために、ネットワークタイプおよびデバイス情報（IPアドレス、デバイスメーカー、デバイスモデル、スマートフォンのオペレーティングシステム、SIMカード情報（SIM State）を含む）を収集いたします。詳細は以下をご確認ください。",
                        "policyName": "『電話番号認証サービスプライバシーポリシー』",
                        "sdkTips": "以下は電話番号認証サービスプロバイダーが使用する関連SDKです：",
                        "link": "https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202112211045_86198.html?spm=a2c4g.11186623.0.0.7e503079Pt4iQ9",
                        "tips": "- 電話番号認証サービスSDK：電話番号によるワンクリックログインを実現するために使用"
                    }
                ],
                notice: "また、アプリがバックグラウンドで動作している際に一部のサードパーティSDKが個人情報を収集する場合があります。",
                noticeTips: "（1）騰訊Bugly SDKはバックグラウンド実行時にSDカード記憶域の情報を読み取り、アプリケーション情報を取得し、発生したクラッシュや具体的なクラッシュ位置をサーバーに送信します。"
            }
        },
        //第八节
        section8: {
            content: [
                "私たちは子供の個人情報の保護を非常に重視しています。当社の製品・ウェブサイト・サービスは主に成人向けです。親または後見人の同意がない限り、子供は自身のアカウントを作成しないでください。地域の法律や習慣により「子供」の定義が異なりますが、私たちは14歳未満の方をすべて「子供」とみなします。",
                "親や後見人の同意に基づいて収集された子供の個人情報については、法律により認められている場合、親や後見人が明確に同意した場合、または子供の保護のために必要な場合のみ情報を保存、利用、開示し、それ以外の場合は速やかに削除いたします。",
                "現在の技術およびビジネスモデルの制限により、子供の個人情報を積極的に識別することが困難です。万が一、ご本人の認識外で子供の個人情報を収集していた場合、または証明可能な後見人の同意なしに収集していた場合がありますら、お早めにご連絡ください。発覚次第、直ちに削除いたします（ただし、法律上保持が必要な場合は除く）。"
            ]
        },
        //第九节
        section9: {
            content: [
                "(a) プライバシーポリシーを変更する場合、当社は本ポリシー、公式ウェブサイトおよびアプリ内のお知らせ機能を通じてご案内いたします。これにより、どのようにしてあなたの個人情報を収集・利用するのか、誰がそれを利用できるのか、またどのような場合に開示されるのかをご理解いただけます。",
                "(b) 当社は本ポリシーを随時変更する権利を有しています。そのため、定期的に内容をご確認ください。重要な変更がある場合には、システムメッセージやSMSでご通知いたします。",
                "(c) 個人情報は大切に管理し、必要な場合のみ第三者と共有してください。もし個人情報が漏洩した場合、特にアプリのユーザー名やパスワードが漏洩した場合は、直ちにお客様サポートまでご連絡ください。適切な対応を迅速に行います。",
                "プライバシーポリシーをご覧いただき誠にありがとうございます！私たちはあなたの個人情報と権利を全力で守ります。改めて、ご信頼いただき感謝申し上げます。"
            ]
        },
        section10: {
            noticePre: "私たちは個人情報保護の専門部署を設け、本ポリシーに基づきあなたの個人情報を保護いたします。ネットワーク情報セキュリティに関するご苦情・通報、または本ポリシーや心光のプライバシー対策、あなたの個人情報に関するご質問・ご意見・ご要望がございましたら、心光の個人情報保護責任者までメールにてお問い合わせください",
            noticeSub: "原則として、ご質問・ご意見・ご要望をいただき、ユーザー資格を確認した日から15日以内に回答いたします。"
        }
    },
    //用户须知
    agreement: {
        mainTitle: "利用規約",
        company: "運営会社：深セン心に光テクノロジー株式会社",
        published_on: "本プライバシーポリシーは以下の日に公開されました：2024年12月20日",
        updated_on: "本プライバシーポリシーは以下の日に更新されました：2025年1月1日",
        title: [
            "1. お客様の権利",
            "2. サービス規約の承認および変更",
            "3. 会員サービス購入に関する声明",
            "4. 会員の購入",
            "5. 会員の有効期限および解約",
            "6. 規約の有効期間および終了",
            "7. 違約責任",
            "8. トラブル解決と適用法"
        ],
        section1: {
            notice: "お客様のプライバシーや個人情報の安全は非常に重要なものと認識しており、お客様のご信頼が私たちにとって最も大切です。中国の関連法令に基づき、以下のような権利を提供し、お客様の個人情報を安全かつ管理できるようにしています。",
            title: [
                "（一）個人情報へのアクセス",
                "（二）個人情報の修正",
                "（三）個人情報の削除",
                "（四）承諾範囲の変更",
                "（五）アカウントの解約",
                "（六）上記リクエストへの対応"
            ],
            firstNotice: "法令で例外が認められている場合を除き、以下の方法により個人情報へのアクセスが可能です。",
            firstTips: "ニックネーム・性別・説明などの基本情報へのアクセス方法：",
            firstTipsSteps: [
                "ログイン後、「伴侶」をクリック",
                "一番上のAIフレンド領域をクリック",
                "個人情報の照会を行う"
            ],
            secondNotice: "個人情報に誤りがある場合は、「（一）個人情報へのアクセス」の手順から直接修正できます。",
            thirdNotice: "次のいずれかの状況において、個人情報の削除を申請することが可能です：",
            thirdTips: [
                "当社が個人情報の処理において法令に違反した場合;",
                "当社が個人情報の収集・利用にあたりお客様の同意を得ていなかった場合;",
                "当社がお客様との合意に反して個人情報を取り扱った場合;",
                "お客様がサービスや製品を利用しなくなった場合、またはアカウントを解約した場合;",
                "当社が今後も製品やサービスを提供しない場合。"
            ],
            thirdEnd: [
                "削除リクエストに対応する場合、当該情報を取得した第三者にも削除依頼を行います（法令で別段の規定がある場合や、これらの第三者が個別に許可を受けている場合を除く）。",
                "削除方法：当社サービスから情報を削除しても、システム内での削除は直ちには行われません。削除の猶予期間を設け、その間は再度復元の依頼が可能です。猶予期間終了後にデータは完全に削除されます。"
            ],
            fourthNotice: "各機能には最低限の個人情報が必要です。それ以外の追加情報については、いつでも同意を与えたり取り下げたりできます。同意を取り下げた場合、該当する個人情報の処理は行いません。",
            fifthNotice: "登録済みのアカウントはいつでもご自身で解約可能です。次の手順で操作してください：",
            fifthNoticeSteps: [
                "ログイン後、「洞察」をクリック",
                "「設定」をクリック",
                "「アカウントとセキュリティ」をクリック",
                "「アカウント解約」をクリック"
            ],
            fifthTips: "アカウントを解約すると、サービス提供を中止し、お客様の要望に応じて個人情報を削除します（法令で別段の規定がある場合を除く）。",
            fifthOtherWise: "次の状況では、法令に基づきご要望にお応えできない場合があります：",
            fifthOtherSteps: [
                "国家および国防の安全に関わる情報;",
                "公衆衛生、公共安全、重要な公益に関係する情報;",
                "犯罪捜査、起訴、裁判、判決の執行などに関する情報;",
                "悪意ある目的や権利の乱用が明らかにある場合;",
                "ご要望への対応が他者の権利を著しく損なう恐れのある場合;",
                "営業秘密に関わる情報;"
            ],
            sixthNotice: [
                "安全性を確保するため、書面による申請や身分証明を求められることがあります。まずは身分確認をお願いした上で対応いたします。身分確認後、30日以内に回答いたします。ご納得いただけない場合は、政府機関や業界主管部門にご相談ください。",
                "適切なリクエストには原則として費用はかかりませんが、繰り返しの申請や通常より負担が大きいもの（新システム開発や現在の慣行の大幅変更が必要なケース、他者の権利に影響を与える可能性のあるもの、バックアップテープ内の情報のように非現実的なものなど）については、費用をいただく場合や対応を控える場合があります。",
                "以下の場合は、ご要望にお応えできない場合があります："
            ],
            sixthSteps: [
                "個人情報管理者が法令上の義務を履行するために必要な場合;",
                "国家および国防の安全に関わる場合;",
                "公衆衛生、公共安全、重要な公益に関係する場合;",
                "犯罪捜査、起訴、裁判、判決の執行などに関する場合;",
                "個人情報管理者が本人が悪意を持って権利を濫用していることを十分な証拠で示せる場合;",
                "生命・財産など重大な権利を守るため本人の同意が難しい場合;",
                "応じることで他者の権利や利益を著しく害する恐れがある場合;",
                "営業秘密に関わる情報;"
            ]
        },
        //第2節
        section2: {
            notice: [
                "本規約は、深セン心に光テクノロジー株式会社が運営するアプリ「心光」のユーザー（以下、「ユーザー」といいます）と同社との間で締結される契約であり、ユーザーの権利に関するものです。この規約では、サービスの利用および関連事項についての権利義務を定めており、ユーザーが本サービスを利用する行為は、本規約のすべての条項に同意したものとみなされます。",
                "本規約が必要に応じて変更される場合、修正箇所または新たな規定はウェブサイトでのお知らせにより公表されます。会員は適切に確認し遵守してください。これらの規定はすべて規約の不可分な一部であり、本文と同等の効力を有します。既存の規約と矛盾する場合は、より新しい効力発生日に基づく規定が優先されます。"
            ]
        },
        //第3節
        section3: {
            notice: [
                "本サービスは、ユーザーがAI関連サービスを受けるために会員資格を取得したいという前提で導入されたものであり、会員と非会員の権限範囲を明確にし、権限範囲の曖昧さによる損害を防ぐことを目的としています。",
                "電話機能、AIチャット、毎週届く手紙などのサービスが含まれますが、これらは会員サービスのごく一部です。今後の開発において、心光はさらに多くの会員専用サービスを提供し、さまざまなニーズに対応して参ります。",
                "課金ミスが生じた場合は、ユーザーが深セン心に光テクノロジー株式会社と協力して原因究明を行う必要があります。それぞれの過失によって生じた損害については当該者が負担し、双方に過失がある場合はその程度に応じて責任を分担します。",
                "心光アプリ内での会員購入以外に、心光外での支払い行為や悪質なハッキングなど違法手段により心光会員資格を取得した行為は、本規約が定める会員サービスには含まれません。これにより生じる一切の法的責任は行為者自身にあり、深セン心に光テクノロジー株式会社は法的責任を追及する権利を有します。"
            ]
        },
        //第4節
        section4: {
            notice: [
                "深セン心に光テクノロジー株式会社は心光アプリ内で、WeChat PayやAlipayなどの決済手段を提供しており、ユーザーが異なる会員期間を選択する際に異なる決済方法から選んで支払いを行い、心光会員資格を取得し、会員特典を楽しむことができます。",
                "支払いが完了したにもかかわらず会員期間が延長されなかったり、会員特典が有効にならなかった場合は、速やかに深セン心に光テクノロジー株式会社にお問い合わせください。会員資格の有効化対応を迅速に行います。"
            ]
        },
        //第5節
        section5: {
            notice: "深セン心に光テクノロジー株式会社が別途規定する場合またはサービス提供が不可能な状況を除けば、ユーザーが取得した会員資格は永久的に有効です。心光会員はバーチャル商品であるため、会員登録および支払いを完了した時点で、本サービス規約を理解し、会員が享受する権利範囲を明確にしているものとみなします。会員資格は即時有効となるため、法令上の例外や、深セン心に光テクノロジー株式会社が提供するサービスが本規約記載の権利と一致しない場合を除き、解約および返金はできません。"
        },
        //第6節
        section6: {
            notice: "本規約は、会員が本サービスの利用または同意を選択した時点で効力を発生し、会員がサービスを終了するか会員資格を解約するまで継続します。また、深セン心に光テクノロジー株式会社が本規約で規定されたサービスを提供できなくなった場合も規約は終了しますが、その際にはユーザーとの連絡を迅速に行い、規約終了の日程を通知し、ユーザーの権利を保障します。",
            otherWise: "以下のいずれかの状況が発生した場合、深セン心に光テクノロジー株式会社は事前の通知なく即時に本規約に基づくサービスの提供を停止することができ、ユーザーまたは第三者に対して一切の責任を負わず、これにより生じる損害はユーザー自身が独自に負担するものとします：",
            case: [
                "ユーザーが中華人民共和国の関連法令または本規約で定められた利用ルールに違反した場合；",
                "ユーザーが個人、企業、団体等の正当な権益（特許権、著作権、商標権、氏名権、名称権、名誉権、栄誉権、肖像権、プライバシー権等）を侵害した場合；",
                "ポルノ、ホラー、政治関連、暴力、血の表現、誹謗中傷、広告など、不快感を与えるコンテンツの投稿は禁止されています。"
            ]
        },
        //第7節
        section7: {
            notice: "一方が契約違反を行った場合、遵守している側は両者で合意された紛争解決手段を通じて補償を受ける権利があります。"
        },
        //第8節
        section8: {
            notice: "深セン心に光テクノロジー株式会社とユーザーは、本規約の履行中に発生した紛争については協議によって解決すべきです。協議で解決できない場合は、当事者のいずれかが裁判所に提訴する権利を持ちます。本規約の解釈、効力および実施に関する一切の問題は、中華人民共和国の法律に準拠します。"
        }
    },
};